import { createContext } from 'react';

const initialState = [];
export const WeatherFutureContext = createContext(initialState);